import { Badge, Flex } from '@chakra-ui/react'
import { formatPrice } from '../../../utils/formatPrice'
import { useMemo } from 'react'

export const Summary = ({ data }) => {
  const { dados_filtrados: dadosFiltrados = [] } = data

  const summary = useMemo(() => {
    const totals = dadosFiltrados.reduce(
      (acc, curr) => {
        const { valor_parcela_real, valor_real_float } = curr

        return {
          totalParcela: acc.totalParcela + valor_parcela_real,
          totalReal: acc.totalReal + valor_real_float,
        }
      },
      { totalParcela: 0, totalReal: 0 }
    )

    return totals
  }, [dadosFiltrados])

  if (data?.length === 0) {
    return null
  }

  console.log('summary', dadosFiltrados)

  return (
    <Flex gap={2}>
      <Badge>Valor total de parcelas: {formatPrice(summary?.totalParcela)}</Badge>
      <Badge>Valor total Real: {formatPrice(summary?.totalReal)}</Badge>
    </Flex>
  )
}
